/* eslint-disable max-len */
export const examPlayerI18n = {
  examPlayer: {
    loading: 'Loading your exam…',
    starting: 'Preparing your exam…',
    errorTitle: 'We could not load your exam',
    errorBody: 'Check your connection and try again. Your saved answers are not affected.',
    retry: 'Try again',
    backToCourse: 'Back to course',
    leave: {
      title: 'Leave the exam?',
      body: 'Your exam is still in progress. The answers you have chosen are saved, and you can come back and continue where you stopped.',
      bodySaving: 'Some of your answers are still saving. If you leave now, those answers may be lost.',
      stay: 'Stay on the exam',
      leave: 'Leave',
    },
    backToCourses: 'Back to my courses',

    intro: {
      title: 'Final exam',
      questions: 'Questions',
      passMark: 'Pass mark',
      passMarkValue: '{percent}%',
      unscoredNotice: 'This exam includes some questions that are not scored. They look like every other question, so answer each one as best you can.',
      savesAsYouGo: 'Your answers save as you go. If you leave, you can come back and continue where you stopped.',
      start: 'Start exam',
      resume: 'Resume exam',
      resumeNotice: 'You have an exam in progress. You have answered {answered} of {total} questions.',
      contentIncomplete: 'Finish all of the course content to unlock the final exam.',
    },

    unavailable: {
      title: 'The exam is not available yet',
      body: 'Please check back later. If this keeps happening, contact support.',
    },

    completed: {
      title: 'You have completed this course',
      body: 'Your certificate has been emailed to you.',
      score: 'Your exam score: {percent}%',
    },

    question: {
      progress: 'Question {current} of {total}',
      progressLabel: 'Exam progress',
      back: 'Back',
      next: 'Next',
      review: 'Review answers',
      saving: 'Saving…',
      saved: 'Answer saved',
      retrying: 'Not saved yet. Trying again…',
      reconnecting: 'Reconnecting. Your answers are kept on this page and will save as soon as the connection is back.',
      empty: 'There are no questions to show.',
      submit: 'Submit exam',
      answerToContinue: 'Choose an answer to continue.',
    },

    review: {
      title: 'Review your answers',
      hint: 'Select a question number to go back to it.',
      hintLocked: 'You cannot go back to earlier questions in this exam.',
      answered: 'Answered',
      unanswered: 'Not answered',
      allAnswered: 'You have answered every question.',
      unansweredCount: 'You have {count} unanswered. Unanswered questions are marked incorrect.',
      gridLabel: 'Questions',
      answeredLabel: 'Question {position}, answered',
      unansweredLabel: 'Question {position}, not answered',
      backToQuestions: 'Back to questions',
      submit: 'Submit exam',
      submitting: 'Submitting…',
      waitingForSaves: 'Waiting for your answers to save…',
      confirmTitle: 'Submit your exam?',
      confirmBody: 'You will not be able to change your answers after you submit.',
      confirmYes: 'Yes, submit',
      confirmNo: 'Keep reviewing',
      confirmNoLast: 'Not yet',
      submitErrorTitle: 'We could not submit your exam',
      submitErrorBody: 'Your answers are saved. Check your connection and try again.',
      rejectedTitle: 'This exam can no longer be changed',
      rejectedBody: 'Reload to see where things stand.',
      reload: 'Reload',
    },

    result: {
      passTitle: 'You passed',
      failTitle: 'Not passed this time',
      yourScore: 'Your score',
      scoreValue: '{percent}%',
      needed: 'You needed {percent}% to pass.',
      certificateSent: 'Your certificate has been emailed to you.',
      certificatePending: 'Your certificate will be emailed to you shortly.',
      downloadCertificate: 'Download certificate',
      downloading: 'Preparing certificate…',
      certificateError: 'We could not download the certificate yet. It has been emailed to you, or try again in a minute.',
      areasTitle: 'How you did by area',
      strong: 'Strong',
      needsReview: 'Review',
      suggestedTitle: 'Lessons to review',
      suggestedBody: 'Go back through these lessons, then retake the exam.',
      retake: 'Retake exam',
    },
  },
};

export const examPlayerI18nEs = {
  examPlayer: {
    loading: 'Cargando su examen…',
    starting: 'Preparando su examen…',
    errorTitle: 'No pudimos cargar su examen',
    errorBody: 'Revise su conexión e inténtelo de nuevo. Sus respuestas guardadas no se ven afectadas.',
    retry: 'Intentar de nuevo',
    backToCourse: 'Volver al curso',
    leave: {
      title: '¿Salir del examen?',
      body: 'Su examen sigue en curso. Las respuestas que eligió están guardadas y puede volver y continuar donde se quedó.',
      bodySaving: 'Algunas de sus respuestas todavía se están guardando. Si sale ahora, podrían perderse.',
      stay: 'Quedarme en el examen',
      leave: 'Salir',
    },
    backToCourses: 'Volver a mis cursos',

    intro: {
      title: 'Examen final',
      questions: 'Preguntas',
      passMark: 'Puntaje para aprobar',
      passMarkValue: '{percent}%',
      unscoredNotice: 'Este examen incluye algunas preguntas que no se califican. Se ven igual que las demás, así que responda cada una lo mejor que pueda.',
      savesAsYouGo: 'Sus respuestas se guardan a medida que avanza. Si sale, puede volver y continuar donde se quedó.',
      start: 'Comenzar examen',
      resume: 'Continuar examen',
      resumeNotice: 'Tiene un examen en curso. Ha respondido {answered} de {total} preguntas.',
      contentIncomplete: 'Termine todo el contenido del curso para desbloquear el examen final.',
    },

    unavailable: {
      title: 'El examen aún no está disponible',
      body: 'Vuelva a intentarlo más tarde. Si el problema continúa, comuníquese con soporte.',
    },

    completed: {
      title: 'Ha completado este curso',
      body: 'Su certificado le ha sido enviado por correo electrónico.',
      score: 'Su puntaje del examen: {percent}%',
    },

    question: {
      progress: 'Pregunta {current} de {total}',
      progressLabel: 'Progreso del examen',
      back: 'Atrás',
      next: 'Siguiente',
      review: 'Revisar respuestas',
      saving: 'Guardando…',
      saved: 'Respuesta guardada',
      retrying: 'Aún no se guarda. Intentando de nuevo…',
      reconnecting: 'Reconectando. Sus respuestas se conservan en esta página y se guardarán en cuanto vuelva la conexión.',
      empty: 'No hay preguntas para mostrar.',
      submit: 'Enviar examen',
      answerToContinue: 'Elija una respuesta para continuar.',
    },

    review: {
      title: 'Revise sus respuestas',
      hint: 'Seleccione el número de una pregunta para volver a ella.',
      hintLocked: 'En este examen no se puede volver a las preguntas anteriores.',
      answered: 'Respondida',
      unanswered: 'Sin responder',
      allAnswered: 'Ha respondido todas las preguntas.',
      unansweredCount: 'Tiene {count} sin responder. Las preguntas sin responder se califican como incorrectas.',
      gridLabel: 'Preguntas',
      answeredLabel: 'Pregunta {position}, respondida',
      unansweredLabel: 'Pregunta {position}, sin responder',
      backToQuestions: 'Volver a las preguntas',
      submit: 'Enviar examen',
      submitting: 'Enviando…',
      waitingForSaves: 'Esperando que se guarden sus respuestas…',
      confirmTitle: '¿Enviar su examen?',
      confirmBody: 'No podrá cambiar sus respuestas después de enviarlo.',
      confirmYes: 'Sí, enviar',
      confirmNo: 'Seguir revisando',
      confirmNoLast: 'Todavía no',
      submitErrorTitle: 'No pudimos enviar su examen',
      submitErrorBody: 'Sus respuestas están guardadas. Revise su conexión e inténtelo de nuevo.',
      rejectedTitle: 'Este examen ya no se puede modificar',
      rejectedBody: 'Vuelva a cargar para ver el estado actual.',
      reload: 'Volver a cargar',
    },

    result: {
      passTitle: 'Aprobó',
      failTitle: 'No aprobó esta vez',
      yourScore: 'Su puntaje',
      scoreValue: '{percent}%',
      needed: 'Necesitaba {percent}% para aprobar.',
      certificateSent: 'Su certificado le ha sido enviado por correo electrónico.',
      certificatePending: 'Su certificado le será enviado por correo electrónico en breve.',
      downloadCertificate: 'Descargar certificado',
      downloading: 'Preparando certificado…',
      certificateError: 'Todavía no pudimos descargar el certificado. Se le envió por correo electrónico, o inténtelo de nuevo en un minuto.',
      areasTitle: 'Su desempeño por área',
      strong: 'Fuerte',
      needsReview: 'Repasar',
      suggestedTitle: 'Lecciones para repasar',
      suggestedBody: 'Repase estas lecciones y luego vuelva a tomar el examen.',
      retake: 'Repetir examen',
    },
  },
};
